import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpService } from './http.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { Interceptor } from './interceptors';
import { ArchwizardModule } from '@y3krulez/angular-archwizard';
import { NgxMaskDirective } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { AgmCoreModule, LazyMapsAPILoaderConfigLiteral } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { WebcamModule } from 'ngx-webcam';
import { ExceptionModalComponent } from './components/exception-modal/exception-modal.component';
import { LoadSpinnerComponent } from './components/load-spinner/load-spinner.component';
import { CareOutreachService } from './careoutreach.service';
import { UiModalComponent } from './components/ui-modal/ui-modal.component';
import { UploadDocumentsComponent } from './components/upload-documents/upload-documents.component';
import { NgSelectDirective } from './directives/ng-select.directive';
import { CallVisorModalComponent } from './components/callvisor-modal/callvisor-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    ExceptionModalComponent,
    LoadSpinnerComponent,
    UiModalComponent,
    UploadDocumentsComponent,
    NgSelectDirective,
    CallVisorModalComponent
  ],
  imports: [
    CommonModule,
    ArchwizardModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    // AgmCoreModule.forRoot({
    //   apiKey: environment?.agmApiKey,
    //   libraries: ['places']
    // }),
    NgSelectModule,
    WebcamModule,
    NgbModule
  ],
  exports: [
    ArchwizardModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    NgSelectModule,
    WebcamModule,
    ExceptionModalComponent,
    LoadSpinnerComponent,
    UiModalComponent,
    UploadDocumentsComponent,
    NgSelectDirective,
    CallVisorModalComponent
  ],
  providers: [HttpService, CareOutreachService,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    //  { provide: AuthGuard, useClass: AuthGuard },
  ]
})
export class SharedModule {
  // lazyMapsAPILoaderConfig?: LazyMapsAPILoaderConfigLiteral
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule
    };
  }
}
